import { render } from "./agenda.vue?vue&type=template&id=57012e2d&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=57012e2d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57012e2d"

export default script